import { defineStore } from 'pinia'

export const useStore = defineStore('store', {
    namespaced: true,
    state: () => ({
        pageLoading: false,
    }),
    getters: {
        pageIsLoading() {
            return this.pageLoading
        }
    },
    actions: {
        refreshStores() {
            // dispatch('refreshModule')
        },

        setPageIsLoading(v) {
            this.pageLoading = v
        }
    }
})
